import classNames from "classnames";
import { FC } from "react";

export interface MultiSelectRadioOption {
  value: string;
  label: string;
}

export interface MultiSelectRadioProps {
  options: MultiSelectRadioOption[];
  value: string[];
  onChange: (selectedValues: string[]) => void;
  name?: string;
  className?: string;
  disabled?: boolean;
}

export const MultiSelectRadio: FC<MultiSelectRadioProps> = ({
  options,
  value,
  onChange,
  name,
  className,
  disabled = false
}) => {
  const handleOptionClick = (optionValue: string) => {
    if (disabled) return;
    
    let updatedValues;
    if (value.includes(optionValue)) {
      // Remove the value if already selected
      updatedValues = value.filter(v => v !== optionValue);
    } else {
      // Add the value if not selected
      updatedValues = [...value, optionValue];
    }
    
    onChange(updatedValues);
  };

  return (
    <div className={classNames("grid grid-cols-1 sm:grid-cols-2 gap-3", className)}>
      {options.map((option) => {
        const isSelected = value.includes(option.value);
        
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => handleOptionClick(option.value)}
            disabled={disabled}
            className={classNames(
              "flex items-center gap-3 p-4 rounded-lg border-2 transition-all text-left",
              disabled
                ? "cursor-not-allowed opacity-50 border-gray-200 bg-gray-50 text-gray-400"
                : isSelected
                ? "border-primary bg-tintPrimary text-primary"
                : "border-gray-200 bg-white text-gray-700 hover:border-gray-300"
            )}
          >
            <div className={classNames(
              "w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all",
              disabled
                ? "border-gray-300"
                : isSelected 
                ? "border-primary bg-primary" 
                : "border-gray-300"
            )}>
              {isSelected && !disabled && (
                <div className="w-2 h-2 bg-white rounded-full"></div>
              )}
            </div>
            <span className="font-medium">{option.label}</span>
          </button>
        );
      })}
    </div>
  );
};